import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { IIkSelectPaymentReadModalData } from '@app/invitation/invitation-b2b/invitation-b2b-client/invitation-b2b-client.interfaces';
import { clickableElement, IClickableElement } from '@app/shared/clickable-element';
import { translate } from '@ngneat/transloco';

@Component({
  selector: 'app-ik-select-payment-change-billing-address-read-modal',
  templateUrl: './ik-select-payment-change-billing-address-read-modal.component.html',
  styleUrls: ['./ik-select-payment-change-billing-address-read-modal.component.scss'],
})
export class IkSelectPaymentChangeBillingAddressReadModalComponent {
  addressLink: IClickableElement;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: IIkSelectPaymentReadModalData,
    public dialogRef: MatDialogRef<IkSelectPaymentChangeBillingAddressReadModalComponent>,
    private domSanitizer: DomSanitizer,
  ) {
    const url = window['ENDPOINTS']?.manager + '/v3/accounts/accounting/addresses';
    this.addressLink = clickableElement({
      text: translate('profils de paiement'),
      href: url,
      callback: () => {
        window.open(url, '_blank');
      },
    });
  }

  get customText(): SafeHtml {
    const text = translate(
      'Vous pourrez a tout moment modifier l\'adresse de facturation par defaut de votre organisation depuis le menu $addressProfil$.',
      { addressProfil: this.addressLink.html },
    );
    return this.domSanitizer.bypassSecurityTrustHtml(text);
  }

  close(): void {
    this.dialogRef.close();
  }
}
